<template>
    <div class="terms-wrapper">
        <app-header-mini :img="'/static/img/sitemap/header.jpg'"></app-header-mini>
        <div class="terms-content">
            <h1>Sitemap</h1>
            <!-- HOME -->
            <p><router-link class="link-main" to="/">Home</router-link></p>
            <!-- ABOUT US -->
            <p><router-link class="link-main" to="/about-the-company/about-us">About us</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/about-us">About us</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/mission-and-values">Mission and values</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/key-figures">Key figures</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/r-and-d">R&amp;D</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/rolling-plant">Rolling plant</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/extrusion-plant">Extrusion plant</router-link></p>
            <p><router-link class="link-sub" to="/about-the-company/timeline">Timeline</router-link></p>
            <!-- MARKETS -->
            <p><router-link class="link-main" to="/markets/building-and-architecture">Markets</router-link></p>
            <p><router-link class="link-sub" to="/markets/building-and-architecture">Building &amp; architecture</router-link></p>
            <p><router-link class="link-sub" to="/markets/automotive">Automotive</router-link></p>
            <p><router-link class="link-sub" to="/markets/transportation">Transportation</router-link></p>
            <p><router-link class="link-sub" to="/markets/packaging">Packaging</router-link></p>
            <p><router-link class="link-sub" to="/markets/distribution">Distribution</router-link></p>
            <!--<p><router-link class="link-sub" to="/markets/packaging">Other industries</router-link></p>
            <!-- PRODUCTS -->
            <p><router-link class="link-main" to="/products">Products</router-link></p>
            <p><router-link class="link-sub" to="/products/rolled-foils/household-foil">Rolled Products - Foiled</router-link></p>
            <p><router-link class="link-sub" to="/products/rolled-sheets-and-strips/standard-sheets-and-strips">Rolled Products - Sheets and Strips</router-link></p>
            <p><router-link class="link-sub" to="/products/extruded/profiles-for-building-and-architecture">Extruded products</router-link></p>
            <!-- NEWS -->
            <p><router-link class="link-main" to="/news/1">News</router-link></p>
            <!-- INVESTORS -->
            <p><router-link class="link-main" to="/investors/management">Investors</router-link></p>
            <p><router-link class="link-sub" to="/investors/management">Management</router-link></p>
            <p><router-link class="link-sub" to="/investors/financial-statements">Financial statements</router-link></p>
            <p><router-link class="link-sub" to="/investors/general-meetings">General meetings</router-link></p>
            <p><router-link class="link-sub" to="/investors/calendar">Calendar for investors</router-link></p>
            <p><router-link class="link-sub" to="/investors/shares">Shares</router-link></p>
            <!-- <p><router-link class="link-sub" to="/investors/presentations">Presentations</router-link></p> -->
            <!-- SUSTAINABILITY -->
            <p><router-link class="link-main" to="/sustainability/environment">Sustainability</router-link></p>
            <p><router-link class="link-sub" to="/sustainability/environment">Environment</router-link></p>
            <p><router-link class="link-sub" to="/sustainability/health-and-safety">Health &amp; safety</router-link></p>
            <p><router-link class="link-sub" to="/sustainability/responsibility">Responsibility</router-link></p>
            <!-- CONTACTS -->
            <p><router-link class="link-main" to="/contacts/sales-department">Contacts</router-link></p>
            <p><router-link class="link-sub" to="/contacts/sales-department">Sales department</router-link></p>
            <p><router-link class="link-sub" to="/contacts/supply-chains">Supply chain</router-link></p>
            <p><router-link class="link-sub" to="/contacts/other-contacts">Other contacts</router-link></p>
            <p><router-link class="link-sub" to="/contacts/locations">Locations</router-link></p>
            <!-- CAREERS -->
            <p><router-link class="link-main" to="/careers/career">Contacts</router-link></p>
            <p><router-link class="link-sub" to="/careers/career">A career in Alcomet</router-link></p>
            <p><router-link class="link-sub" to="/careers/open-positions">Open positions</router-link></p>
            <p><router-link class="link-sub" to="/careers/internships">Internships</router-link></p>
            <!-- <p><router-link class="link-sub" to="/careers/application-form">Application form</router-link></p> -->
            <!-- TERMS AND CONDITIONS -->
            <p><router-link class="link-main" to="">Terms &amp; conditions</router-link></p>
            <p><router-link class="link-sub" to="/terms-of-use">Terms and conditions of use</router-link></p>
            <p><router-link class="link-sub" to="/disclosure-policy">Disclosure policy</router-link></p>
            <p><router-link class="link-sub" to="/personal-data">Personal data</router-link></p>
            <p><router-link class="link-sub" to="/sitemap">Sitemap</router-link></p>
        </div>
    </div>
</template>

<script>
import HeaderMini from "./shared/HeaderMini";
export default {
  components: {
    appHeaderMini: HeaderMini
  }
};
</script>

<style scoped>
.terms-content {
  padding: 0 0 60px;
}
.terms-content > h1 {
  font-size: 34px;
  font-weight: 500;
  margin: 0 auto 25px;
  width: 800px;
}
.terms-content > p {
  font-size: 19px;
  text-align: justify;
  line-height: 32px;
  margin: 5px auto;
  width: 800px;
}
.link-main {
  font-weight: 700;
}
.link-sub {
  font-size: 16px;
  margin-left: 20px;
}
@media screen and (max-width: 1000px) {
  .terms-content > h1 {
    font-size: 20px;
    padding: 0 30px;
    width: 100%;
  }
  .terms-content > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sitemap.vue